import React from "react";
import { graphql } from "gatsby";
import styled from 'styled-components';
import { Layout } from "../components/Layout";
import { STYLES } from "../styles/Styles";
import { ShareLinks } from "../components/ShareLinks";
import { useMediaQuery } from 'react-responsive';
import { ProductLink } from "../components/ProductLink";
import { Helmet } from "react-helmet";
import Img from 'gatsby-image';
import { AboutCopy } from "../components/Copy";

interface Props {
  data: any
}

const AboutPage = (props: Props) => {

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const aboutPhoto = props.data.aboutPhoto.childImageSharp.fluid;
  const aboutPhoto2 = props.data.aboutPhoto2.childImageSharp.fluid;

  return (
    <Layout inverseColor={isTabletOrMobile ? true : false} headerStyle={{ zIndex: 1 }} footerLogo={false}>
      <Helmet>
        <title>About David Pocock</title>
        <meta name="description" content="Get to know more about David Pocock and how he found his passion for photography and wildlife while growing up in Zimbabwe." />
        <meta name="site-section" content="Explore" />
        <meta name="page-template" content="Story Page" />
        <meta name="page-category" content="Get Inspired" />
        <meta name="og:title" property="og:title" content="About David Pocock" />
        <meta name="og:description" property="og:description" content="Get to know more about David Pocock and how he found his passion for photography and wildlife while growing up in Zimbabwe." />
      </Helmet>
      <AboutPageContainer>
        <LeftSection>
        <AboutPhoto fluid={aboutPhoto} />
        <AboutPhoto fluid={aboutPhoto2} imgStyle={{objectPosition: 'center 30%'}}/>
        </LeftSection>
        <AboutDetails>
          <Title>An athlete with purpose beyond the game.</Title>
          <AboutCopy />
          <End>
            <Gear>
              <GearTitle>David's kit in the Tarkine</GearTitle>
              <div><ProductLink product='EOS-1D X Mark II' /></div>
              <div><ProductLink product='EOS R' /></div>
              <div><ProductLink product='RF 24-105mm f/4L IS USM' /></div>
              <div><ProductLink product='EF 200-400mm f/4L IS USM Extender 1.4X' /></div>
              <div><ProductLink product='EF 100mm f/2.8L Macro IS USM' /></div>
            </Gear>
            <GearTitle style={{marginBottom: 0}}>Follow David Pocock</GearTitle>
            <ShareLinks displayStyle='icons' linkTo='david' style={{padding: '2rem 0'}}/>
          </End>
        </AboutDetails>
      </AboutPageContainer>

    </Layout>
  )
}

const AboutPageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  @media(min-width: ${STYLES.desktopSize}) {
    flex-direction: row;
    padding: 140px 4rem 1rem 4rem;
  }
`;

const Title = styled.h2`
  font-family: 'Proxima Nova Extra Condensed',sans-serif;
`;

const LeftSection = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media(min-width: ${STYLES.desktopSize}) {
      width: 50%;
      height: auto;
      height: 100%;
    }
`;

const AboutPhoto = styled(Img)`
  width: 100%;
  height: 50vh;
  object-fit: cover;
  object-position: 70% 50%;
  @media(min-width: ${STYLES.desktopSize}) {
      height: 508px;
      :not(:first-child) {
        margin-top: 1.5rem;
      }
    }
  @media(max-width: ${STYLES.desktopSize}) {
    :not(:first-child) {
      display: none;
    }
  }
`;

const AboutDetails = styled.section`
  display: flex;
  flex-direction: column;
  @media(max-width: ${STYLES.desktopSize}) {
    padding: 1rem;
  }
  @media(min-width: ${STYLES.desktopSize}) {
    margin-left: 4rem;
    width: 50%;
  }
`;

const End = styled.div`
  padding-top: 2rem;
`;

const Gear = styled.div`
  padding-bottom: 2rem;
  line-height: 1.5;
`;

const GearTitle = styled.h3`
  font-family: 'Proxima Nova Extra Condensed', sans-serif;
  font-size: 30px;
`;

export default AboutPage;

export const pageQuery = graphql`
  query {
    aboutPhoto: file(relativePath: { eq: "photos/21. Pocock_Tassie-217.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 3854) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    aboutPhoto2: file(relativePath: { eq: "photos/32. Pocock_Tassie-303.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 3854) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;